import { ApdmBuildCardKind, ApdmBuildCardView } from '@euler/model/apdm';
import { useServiceFactory } from '@euler/services/factory';
import { useEffect, useState } from 'react';

export type PlanCardState =
  | { kind: 'loading' }
  | { kind: 'ready'; view: ApdmBuildCardView }
  /** The reply kept no such card, or the read failed. */
  | { kind: 'missing' };

/**
 * The card a build reply kept, read back by the reply's id: the history
 * shows what the reply showed, never a fresh count.
 */
export function usePlanCard(
  messageId: string | undefined,
  card: ApdmBuildCardKind,
): PlanCardState {
  const { apdmCampaignService } = useServiceFactory();
  const [state, setState] = useState<PlanCardState>({ kind: 'loading' });
  useEffect(() => {
    if (!messageId) return;
    let active = true;
    setState({ kind: 'loading' });
    apdmCampaignService
      .planCard({ messageId, card })
      .then(result => {
        if (active)
          setState(
            result.card
              ? { kind: 'ready', view: result.card }
              : { kind: 'missing' },
          );
      })
      .catch(error => {
        console.error('APDM plan card failed', error);
        if (active) setState({ kind: 'missing' });
      });
    return () => {
      active = false;
    };
  }, [apdmCampaignService, messageId, card]);
  return state;
}

/** Only an id the server issued names a kept card; a live key does not. */
export function isAiMessageId(value: string | undefined): value is string {
  return !!value && /^aim_[a-z0-9]{26}$/.test(value);
}
